import { render } from "./SoftwareManager.vue?vue&type=template&id=2d00bb46"
import script from "./SoftwareManager.vue?vue&type=script&lang=js"
export * from "./SoftwareManager.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__